import {
  SET_TAXONOMY_DATA,
  SET_CURRENT_TAXONOMY_L2_DATA,
  SET_T1T2_PRODUCT_DATA,
} from "../actions/TaxonomyActions";

export const initialState = {
  taxonomyData: [],
  currentTaxonomyL2Data: null,
  currentT1T2ProductData: null,
};

export default function (state = initialState, actions) {
  switch (actions.type) {
    case SET_TAXONOMY_DATA:
      return { ...state, taxonomyData: actions.payload };
    case SET_CURRENT_TAXONOMY_L2_DATA:
      return { ...state, currentTaxonomyL2Data: actions.payload };
    case SET_T1T2_PRODUCT_DATA:
      return { ...state, currentT1T2ProductData: actions.payload };
    default:
      return state;
  }
}
